import React from 'react';
import dsTokens from '@frete.com/fuel-foundation/fretebras/theme.json';
import { PER_PAGE } from '@constants';
import {
  FuelButton,
  FuelGridContainer,
  FuelGridItem,
  FuelTypography,
} from '@frete.com/fuel-react';
import BaseInput from '../BaseInput/BaseInputStyles';
import { Paper } from '../Paper/PaperStyles';

interface PaginationPropsInterface {
  onChange: (nextPage: number) => void;
  page: number;
  total: number;
  isMobile: boolean;
}

const perPage = Number(PER_PAGE);

const options = (total: number) =>
  new Array(total).fill('').map((item, index) => (
    <option key={`option-${index + 1}`} value={index + 1}>
      {index + 1}
    </option>
  ));

function Pagination({
  onChange,
  page,
  total,
  isMobile,
}: PaginationPropsInterface) {
  const totalPages = Math.ceil(total / perPage);
  const { km2 } = dsTokens.spacing;

  return (
    <Paper color="neutral-weak" verticalSpacing={3} horizontalSpacing={4}>
      <FuelGridContainer
        style={{ alignItems: 'center', columnGap: km2, margin: 0 }}
      >
        <FuelGridItem sm={2} md={2} lg={4} xlg={4}>
          <FuelTypography size="caption" weight="bold" color="neutral-weak">
            {page} de {totalPages}
          </FuelTypography>
        </FuelGridItem>
        <FuelGridItem
          sm={2}
          md={6}
          lg={8}
          xlg={8}
          style={{
            justifySelf: 'end',
            display: 'flex',
            alignItems: 'center',
            gap: km2,
          }}
        >
          {!isMobile && (
            <FuelTypography size="caption" weight="bold" color="neutral-weak">
              Você está na página
            </FuelTypography>
          )}
          <BaseInput
            style={{ width: '62px' }}
            id="pagination-dropdown"
            as="select"
            onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
              onChange(parseInt(e.target.value, 10))
            }
            $inputSize="small"
            value={page.toString()}
          >
            {options(totalPages)}
          </BaseInput>
          <FuelButton
            variant="secondary"
            onClick={() => onChange(page - 1)}
            disabled={page === 1}
            onlyIcon
            trailingIcon="arrow-left"
          />
          <FuelButton
            variant="secondary"
            onlyIcon
            trailingIcon="arrow-right"
            onClick={() => onChange(page + 1)}
            disabled={page === totalPages}
          />
        </FuelGridItem>
      </FuelGridContainer>
    </Paper>
  );
}

export default Pagination;
